/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var bodybuilder = require('bodybuilder');
var Ladda = require('ladda');

var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');

var StringCell = require('common/backgrid/StringCell');
var LinkCell = require('common/backgrid/LinkCell');
var ButtonLinkCell = require('common/backgrid/ButtonLinkCell');
var SearchHighlightCell = require('common/backgrid/SearchHighlightCell');
var ElasticSearchSummaryView = require('common/views/ElasticSearchSummaryView');

var DepInternalSidebarNavView = require('../../common/views/DepInternalSidebarNavView');
var SearchDepPeople = require('../../common/services/SearchDepPeople');
var personTypes = require('../../common/services/dep-person-types.json');

require('../styles/DepPersonSearchView.css');
var tmplDepPersonSearchView = require('../templates/DepPersonSearchView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepPersonSearchView,

  className: 'dep-person-search-view container-fluid',

  ui: {
    sideBar: '.side-bar-container',
    searchSummary: '.search-summary',
    searchResultsContainer: '.search-results-container',
    search: '.search',
    clearFilters: '.clear-filters',
    formInputs: ':input'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchResultsContainer: '@ui.searchResultsContainer',
    searchSummary: '@ui.searchSummary'
  },

  events: {
    'click @ui.search': 'onClickSearch',
    'click @ui.clearFilters': 'onClickClearFilters',
    'keydown @ui.formInputs': 'onKeydownOfInputs'
  },

  templateHelpers: function() {
    return {
      personTypes: personTypes
    };
  },

  onBeforeShow: function() {
    this.showChildView('sideBar', new DepInternalSidebarNavView());

    this.searchSummaryView = new ElasticSearchSummaryView({
      model: new Backbone.Model({
        searchLimit: this.model.get('searchLimit')
      })
    });
    this.showChildView('searchSummary', this.searchSummaryView);

    this.searchResults = new GridView({
      columns: [
        {
          name: 'firstName',
          label: 'First Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'middleInitial',
          label: 'Middle I.',
          cell: StringCell,
          headerCell: 'custom',
          width: 5,
          editable: false
        },
        {
          name: 'lastName',
          label: 'Last Name',
          cell: StringCell,
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'personTypeDisplay',
          label: 'Person Type',
          cell: StringCell,
          headerCell: 'custom',
          width: 15,
          editable: false
        },
        {
          name: 'entityName',
          label: 'Entity Name',
          cell: LinkCell.extend({
            emptyText: '--',
            newTab: true,
            href: function(model) {
              var entityId = model.get('entityId');
              var url = entityId ? '#dep/entity/' + entityId + '/dashboard' : '';
              return url;
            }
          }),
          headerCell: 'custom',
          width: 20,
          editable: false
        },
        {
          name: 'highlight',
          label: 'Matches',
          cell: SearchHighlightCell.extend({
            highlightLabels: {
              firstName: 'First Name',
              lastName: 'Last Name',
              personType: 'Person Type'
            }
          }),
          headerCell: 'custom',
          width: 20,
          sortable: false,
          editable: false
        },
        {
          name: '',
          label: '',
          cell: ButtonLinkCell.extend({
            name: 'Open',
            newTab: true,
            buttonClass: 'btn-primary btn-sm',
            href: function(model) {
              var entityId = model.get('entityId');
              var personId = model.get('personId');
              var personType = model.get('personType');
              switch (personType) {
                case 'ENTITY_CONTACT':
                  return '#dep/entity/' + entityId + '/contact/' + personId + '/dashboard';
                case 'ENTITY_OFFICER':
                  return '#dep/entity/' + entityId + '/officer/' + personId + '/dashboard';
                case 'ENTITY_DIRECTOR':
                  return '#dep/entity/' + entityId + '/director/' + personId + '/dashboard';
                case 'IRREGULARITY':
                  return '#dep/entity/' + entityId + '/irregularity/' + personId + '/dashboard';
                default:
                  return '#';
              }
            }
          }),
          headerCell: 'custom',
          width: 5,
          sortable: false,
          editable: false
        }
      ],
      collection: new PageableCollection([], { pageSize: 25 }),
      emptyText: 'No People Found'
    });

    this.showChildView('searchResultsContainer', this.searchResults);

    this.$('.backgrid.table').addClass('table-bordered');
  },

  onKeydownOfInputs: function(e) {
    // Searches on press of enter
    if (e.keyCode === 13) {
      this.onClickSearch(e);
    }
  },

  onClickSearch: function() {
    var self = this;
    var data = Syphon.serialize(this, {
      inputReaders: Syphon.SearchInputReaderSet
    });

    // If no inputs were given, do not perform a search.
    if (!data.firstName && !data.lastName && !data.personType) {
      return;
    }
    this.searchSummaryView.reset();

    var l = Ladda.create(this.ui.search[0]);
    l.start();
    var body = bodybuilder();

    if (data.firstName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'firstName', {
          query: data.firstName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'firstName', data.firstName.toLowerCase() + '*');
        return b;
      });
    }

    if (data.lastName) {
      body.query('bool', function(b) {
        b.orQuery('match', 'lastName', {
          query: data.lastName,
          fuzziness: 'AUTO',
          analyzer: 'standard'
        });
        b.orQuery('wildcard', 'lastName', data.lastName.toLowerCase() + '*');
        return b;
      });
    }

    if (data.personType) {
      body.query('match', 'personType', data.personType);
    }

    body.size(this.model.get('searchLimit'));
    body.rawOption('highlight', require('./dep-person-search-highlights.json'));
    var bodyObj = body.build();
    // Keep for testing
    // console.log(JSON.stringify(bodyObj, null, 2));
    // console.log('formData:', data);
    SearchDepPeople(bodyObj, data)
      .done(function(data) {
        l.stop();
        self.searchResults.collection.fullCollection.reset(data.hits);
        self.searchSummaryView.display(data);
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickClearFilters: function() {
    this.ui.formInputs.val('');
  }
});
